import CustomFilterSelect from "./CustomFilterSelect";

const FilterErrorCode = (props: any) => {
  // | R01 [Insufficient Funds]                                                           |
  // | R02 [Account Closed]                                                          |
  // | R03 [No Account/Unable to Locate Account]                                      |
  // | R04 [Invalid Account Number Structure]                                         |
  // | R08 [Payment Stopped]                                                          |
  // | R09 [Uncollected Funds]                                                        |
  // | R10 [Customer Advises Not Authorized, Improper, or Ineligible]                 |
  // | R11 [Check Truncation Entry Returned]                                          |
  // | R16 [Account Frozen]                                                           |
  // | R20 [Non-Transaction Account]                                                   |
  // | R29 [Corporate Customer Advises Not Authorized]
  // |  [Account or customer restricted.]                                             |
  // |  [Insufficient funds.]                                                         |
  // |  [Invalid amount. The supplied amount is greater than your transaction limit.] |
  // |  [Invalid amount. The supplied amount must be a positive number.]              |
  // |  [Invalid destination funding source.]                                         |
  // |  [Invalid funding source.]                                                     |
  // |  [Receiver restricted.]                                                        |
  // | [Sender restricted.]
  // | A transfer task exists already.                                                |
  // | More than(equal) 2 failed checking balance.                                    |
  // | More than(equal) 2 failed transfers.                                           |
  // | No Source FundingSource Found.                                                 |
  // | No Target FundingSource found.
  // | System generated transfer failed during grace period, skip it. |
  // | The request body contains bad syntax or is incomplete.         |
  // | There's 1 failed checking balance before due date.

  // Balance, Account
  // R01
  // R02
  // R03
  // R04
  // R08
  // R09
  // R10
  // R11
  // R16
  // R20
  // R29
  // Account Error
  // Insufficent
  // Transfer Error
  // ACH Paused
  // Code Error
  const FilterData = [
    { id: "R01", name: "R01" },
    { id: "R02", name: "R02" },
    { id: "R03", name: "R03" },
    { id: "R04", name: "R04" },
    { id: "R08", name: "R08" },
    { id: "R09", name: "R09" },
    { id: "R10", name: "R10" },
    { id: "R11", name: "R11" },
    { id: "R16", name: "R16" },
    { id: "R20", name: "R20" },
    { id: "R29", name: "R29" },
    { id: "Balance Error", name: "Balance Low" },
    { id: "Account Error", name: "Account Error" },
    // { id: "Insufficent", name: "Insufficent" },
    // { id: "Transfer Error", name: "Transfer Error" },
    // { id: "ACH Paused", name: "ACH Paused" },
    // { id: "Code Error", name: "Code Error" },
    // { id: "No results found", name: "No results found" },
  ];
  return (
    <CustomFilterSelect
      source="errorCode"
      label="Error Code"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterErrorCode;
